Vue.component("quotes-invoices-settings", {

    mixins: [require("../../../mixins/address.js")],

    props: ["settings"],

    data () {
        return {
            mutableBankString: this.settings.full_bank_detail_string,
            form: this.setupNewForm(this.settings),
        };
    },

    computed: {
        logoUploadUrl () {
            return "/settings/quotes-invoices/" + this.settings.id + "/logo";
        },

        bankDetailsString () {
            return !_.isEmpty(this.mutableBankString) ? this.mutableBankString : "No bank details";
        },

        quotesInvoicesAddress () {
            return !_.isEmpty(this.form.address.full_address) ? this.form.address.full_address : "No address";
        },

        vatTypes () {
            let types = [];

            if (this.state) {
                this.state.vat_percentages.forEach(vat => {
                    // for now we are not handling custom vat in the same way as transaction requests, quotes/invoices needs a rewrite
                    if (vat.key !== "Custom") {
                        types.push({
                            key: vat.key.replace("_default", ""),
                            value: vat.value
                        });
                    }
                });
            }

            return types;
        },
    },

    methods: {

        setupNewForm (data) {
            return new AppForm({
                address: data.address,
                company_name: data.company_name,
                trading_name: data.trading_name,
                company_registration_number: data.company_registration_number,
                vat_id: data.vat_id,
                vat_percentage: data.vat_percentage ? data.vat_percentage : "Select VAT %",
                vat_calculation: data.vat_calculation,
                invoices_due_after: data.invoices_due_after,
                phone: data.phone,
                email: data.email,
                website: data.website,
                quote_terms: data.quote_terms,
                invoice_terms: data.invoice_terms,
                currency: data.currency,
                account_name: data.account_name,
                bank: data.bank,
                branch_code: data.branch_code,
                account_number: data.account_number,
                account_type: data.account_type,
            });
        },

        showBankDetailsModal () {
            $("#bankDetailsModal").modal("show");
        },

        hideBankDetailsModal () {
            $("#bankDetailsModal").modal("hide");
        },

        addressUpdated (address) {
            this.form.address = address;
        },

        updateSettings () {
            App.patch("/settings/quotes-invoices/" + this.settings.id + "/update", this.form)
            .then((response) => {
                this.hideBankDetailsModal();
                this.mutableBankString = response.full_bank_detail_string;
                toastr.success("Quotes & invoice settings updated");
            }).catch((errors) => {
                toastr.error("Could not update Quotes * Invoice settings");
            });
        }
    }
});
